/**
 * Video Testimonials Data
 * Customer video reviews
 */
const assetsUrl = `${window.template_root}/src/public/`;

export const videoTestimonials = [
  {
    id: "1",
    src: `${assetsUrl}img/testimonial-1.webp`,
    poster: `${assetsUrl}img/poster-1.webp`,
    headline:
      "I completely forgot about the weight swings throughout the year!",
    name: "Sarah M.",
    isImage: true,
  },
  {
    id: "2",
    src: `${assetsUrl}img/testimonial-2.webp`,
    poster: `${assetsUrl}img/poster-2.webp`,
    headline:
      "With this symbiotic cocktail, my stomach got flatter and cravings stopped completely.",
    name: "Jennifer L.",
    isImage: true,
  },
  {
    id: "3",
    src: `${assetsUrl}img/testimonial-3.webp`,
    poster: `${assetsUrl}img/poster-3.webp`,
    headline:
      "After five weeks, I lost those stubborn pounds from my belly that haven't moved for years!",
    name: "Amanda R.",
    isImage: true,
  },
  {
    id: "4",
    src: `${assetsUrl}img/testimonial-4.webp`,
    poster: `${assetsUrl}img/poster-4.webp`,
    headline:
      "Healthy gut - healthy skin. Naori helps me maintain healthy weight and my skin is glowing!",
    name: "Michelle T.",
    isImage: true,
  },
  {
    id: "5",
    src: `${assetsUrl}img/testimonial-5.webp`,
    poster: `${assetsUrl}img/poster-5.webp`,
    headline: "Bloated tummy no more!",
    name: "Rachel K.",
    isImage: true,
  },
  {
    id: "6",
    src: `${assetsUrl}img/testimonial-6.webp`,
    poster: `${assetsUrl}img/poster-1.webp`,
    headline:
      "After the first bottle, I switched to a subscription. It's my secret to staying thin after 3 kids",
    name: "Lisa P.",
    isImage: true,
  },
  {
    id: "7",
    src: `${assetsUrl}img/testimonial-7.webp`,
    poster: `${assetsUrl}img/poster-2.webp`,
    headline:
      "All I can say is that Naori is the only thing that helped me lose weight. It wouldn't move with diets or sport.",
    name: "Sophie W.",
    isImage: true,
  },
];

export default videoTestimonials;
